import { TreeInitial } from '@/models/CardapioModel';
import { defineStore } from 'pinia';

export const usePackage = defineStore('usePackage', {
  state: () => ({
    package: [] as TreeInitial[] | [],
  }),
  actions: {    
    setPackage(treeInitial: TreeInitial[]) {
      this.package = treeInitial.filter((item) => item.level == 5 && item.codPackage )
    }  
  },
  getters: {
    getPackage: (state) => state.package,
  },
})